// extracted by mini-css-extract-plugin
module.exports = {"search":"search-module--search--2S5Ue","findIcon":"search-module--findIcon--10yBY","clearButton":"search-module--clearButton--2_SS9"};